export default function sliderCaptions() {
	const sliderCap = $('.sliderWithCaptions__slider');

	if (sliderCap.length > 0) {
		sliderCap.each(function (num, elem) {
			elem = $(elem);
			elem.slick({
				dots: false,
				infinite: false,
				autoplay: false,
				speed: 500,
				cssEase: 'ease',
				cssEase: 'ease-in-out',
				touchMove: true,
				arrows: true,
				prevArrow: $('.sliderWithCaptions__left')[num],
				nextArrow: $('.sliderWithCaptions__right')[num],
				cssEase: 'ease',
				accessibility: true,
				adaptiveHeight: true,
				// infinite: true,
				cssEase: 'ease-in-out',
			});
			elem.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				elem = $(this);
				let slickDots = elem.find('.slick-dots');
				let left = elem.siblings('.sliderWithCaptions__left');
				let right = elem.siblings('.sliderWithCaptions__right');
				let imgHeight = elem
					.find('.slick-slide[data-slick-index=' + currentSlide + ']')
					.find('img')
					.height();
				let changeHeight = imgHeight / 2;
				left.css('top', changeHeight + 'px');
				right.css('top', changeHeight + 'px');
			});
			$(window).on('load resize', function () {
				elem = $(elem);
				elem.slick('setPosition');
				let slickDots = elem.find('.slick-dots');
				let left = $('.sliderWithCaptions__left')[num];
				let right = $('.sliderWithCaptions__right')[num];
				let startHeight = elem.find('.slick-current').find('img').height();
				let startArrows = startHeight / 2;
				let textHeight = elem
					.find('.slick-current')
					.find('.sliderWithCaptions__p')
					.height();
				let containerHeight = elem
					.find('.slick-current')
					.find('.sliderWithCaptions__slide')
					.height();
				let dotHeight = containerHeight - (textHeight + 55);
				slickDots.css('top', dotHeight + 'px');
				left.style.top = startArrows + 'px';
				right.style.top = startArrows + 'px';
			});
		});
	}

	const imageWithCaption = $('.imageWithCaption__slider');

	if (imageWithCaption.length > 0) {
		imageWithCaption.each(function (num, elem) {
			elem = $(elem);
			elem.slick({
				dots: true,
				infinite: true,
				autoplay: false,
				speed: 0,
				touchMove: true,
				arrows: true,
				speed: 500,
				adaptiveHeight: true,
				cssEase: 'ease-in-out',
				prevArrow: $('.imageWithCaption__left')[num],
				nextArrow: $('.imageWithCaption__right')[num],
				accessibility: true,
				infinite: false,
				cssEase: 'ease-in-out',
			});
			elem.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				elem = $(this);
				let slickDots = elem.find('.slick-dots');
				let left = elem.siblings('.imageWithCaption__left');
				let right = elem.siblings('.imageWithCaption__right');
				let imgHeight = elem
					.find('.slick-slide[data-slick-index=' + currentSlide + ']')
					.find('img')
					.height();
				let changeHeight = imgHeight / 2;
				let textHeight = elem
					.find('.slick-slide[data-slick-index=' + currentSlide + ']')
					.find('.imageWithCaption__p')
					.height();
				let containerHeight = elem
					.find('.slick-slide[data-slick-index=' + currentSlide + ']')
					.find('.imageWithCaption__slide')
					.height();
				let dotHeight = containerHeight - (textHeight + 55);

				slickDots.css('top', dotHeight + 'px');
				left.css('top', changeHeight + 'px');
				right.css('top', changeHeight + 'px');
			});
		});

		$(window).on('load resize', function () {
			imageWithCaption.each(function (num, elem) {
				elem = $(elem);
				elem.slick('setPosition');

				let slickDots = elem.find('.slick-dots');
				let left = $('.imageWithCaption__left')[num];
				let right = $('.imageWithCaption__right')[num];

				let startHeight = elem
					.find('.slick-slide[data-slick-index=0]')
					.find('img')
					.height();
				let startArrows = startHeight / 2;
				let textHeight = elem
					.find('.slick-slide[data-slick-index=0]')
					.find('.imageWithCaption__p')
					.height();
				let containerHeight = elem
					.find('.slick-slide[data-slick-index=0]')
					.find('.imageWithCaption__slide')
					.height();
				let dotHeight = containerHeight - (textHeight + 55);
				slickDots.css('top', dotHeight + 'px');
				left.style.top = startArrows + 'px';
				right.style.top = startArrows + 'px';
			});
		});
	}
}
